/** Transport-neutral authorization error used by shared presentation code. */
export class ForbiddenError extends Error {
  public constructor(detail: string) {
    super(detail);
  }
}
